module.exports = __webpack_public_path__ + "static/media/ss9.353b49ed.jpg";